import ClipboardJS from 'clipboard';

function clipboardTrigger(copylink) {
  return new ClipboardJS(copylink);
}

const clipboardInit = (copylink: HTMLElement) => clipboardTrigger(copylink);

export default clipboardInit;
